<template>
  <div
    ref="root"
    v-show="visible"
    class="popup login"
  >
    <amplify-authenticator
      v-if="visible"
      ref="authenticator"
      :authConfig="authConfig"
    />
  </div>
</template>

<script>

import { Auth } from 'aws-amplify';
import PopupBase from './PopupBase.vue';

export default {
  name: 'AmplifyLoginPopup',
  extends: PopupBase,

  data () {
    return {
      authConfig: {
        signUpConfig: {
          signUpFields: [
            {
              label: 'Username',
              key: 'username',
              required: true,
              displayOrder: 1,
              type: 'email'
            },
            {
              label: 'Password',
              key: 'password',
              required: true,
              displayOrder: 2,
              type: 'password'
            }
          ],
          hiddenDefaults: ['email', 'phone_number']
        },
        confirmSignUpConfig: {},
        forgotPasswordConfig: {}
      }
    };
  },

  mounted () {
    document.addEventListener('click', (e) => {
      if (this.visible) {
        // hide if a user clicks on the outside of a form
        let path = this.getPath(e);
        if (!path.includes(this.$refs.authenticator.$el)) {
          this.hide();
        }
      }
    });

    Auth.currentAuthenticatedUser().then(user => {
      // console.log("Resgistered user:", user)
    }).catch(() => {
      console.log("Not registered")
    });

    this.$Amplify.Hub.listen('auth', (data) => {
      const { payload } = data;
      if (payload.event === 'signIn') {
        this.$emit('successLogin');
      }
      if (payload.event === 'signOut') {
        console.log(this.$refs.authenticator);
      }
    });
  },

  methods: {
  }
};

</script>



// WEBPACK FOOTER //
// src/components/AmplifyLoginPopup.vue